import React from 'react'
import { AuthAPI, PedidoAPI, UsuarioAPI } from '../api'
import { UsuarioContext } from './UsuarioContext'
import { Alerts } from '../components/Simple'
import moment from 'moment'

export const AgendamentoContext = React.createContext({
  sttCtxAgend: {
    pedido: {},
    pedidoStt: {
      pedidoAprovado: false,
      pedidoCriadoPorUser: false,
      pedidoRealizado: false,
      pedidoAvaliado: false,
      pedidoCancelado: false,
    },
    horaFixaSelected: null,
    reagendamento: {},

    bttAgSel: 'avulsos',
    avulsoSel: 'Todos',
    typePed: 'Todos',
    offset: 0,
    maxScroll: 0,
    scroll: 0,

    avulsos: [],
    fixos: [],
    diarias: [],

    diariaSel: null,
    erroComunic: false,
  },
  modaisAgend: {
    avaliacao: false,
    cancelamento: false,
    cancelamentoDiaria: false,
    historicoAgendamento: false,
    horaFixa: false,
    situacao: false,
    tipo: false,
  },
  loadAgend: {
    page: true,
    avaliacao: false,
    cancelamento: false,
    cancelamentoDiaria: false,
    horaFixa: false,
    list: false,
    pagina: false,
    diaria: false,
  },
  // Disabilitar esses erros das variaveis
  actionsAgend: {
    // eslint-disable-next-line no-unused-vars
    BuscarPedidoId: async idpedido => {},
    // eslint-disable-next-line no-unused-vars
    BuscarAgendamentosAvulsos: async countAll => {},
    // eslint-disable-next-line no-unused-vars
    BuscarMensalistasUsuario: async countAll => {},
    // eslint-disable-next-line no-unused-vars
    BuscarDiariasUsuario: async countAll => {},
    // eslint-disable-next-line no-unused-vars
    CancelarAgendamento: async motivo => {},
    // eslint-disable-next-line no-unused-vars
    handleSttCtxAgend: (key, value) => {},
    // eslint-disable-next-line no-unused-vars
    handleModaisAgend: (key, value) => {},
    // eslint-disable-next-line no-unused-vars
    handleLoadAgend: (key, value) => {},
    ReagendarAgendamento: () => {},
    ResetReagendamento: () => {},
  },
  actionsHoraFixa: {
    // eslint-disable-next-line no-unused-vars
    BuscarHoraFixaId: async idmensalista => {},
  },
  actionsDiaria: {
    // eslint-disable-next-line no-unused-vars
    BuscaDiariaId: async idcompraDayuse => {},
    // eslint-disable-next-line no-unused-vars
    CancelarDiaria: async motivo => {},
    // eslint-disable-next-line no-unused-vars
    handleModaisAgend: (key, value) => {},
  },
})

export default function AgendamentoContextProvider({ children }) {
  const { userUCtx } = React.useContext(UsuarioContext)

  const [sttCtxAgend, setSttCtxAgend] = React.useState({
    pedido: {},
    pedidoStt: {
      pedidoAprovado: false,
    },
    horaFixaSelected: null,
    reagendamento: {},

    bttAgSel: 'avulsos',
    avulsoSel: 'Todos',
    typePed: 'Todos',
    offset: 0,
    maxScroll: 0,
    scroll: 0,

    avulsos: [],
    fixos: [],
    diarias: [],

    diariaSel: null,
    erroComunic: false,
  })

  const [modaisAgend, setModaisAgend] = React.useState({
    avaliacao: false,
    cancelamento: false,
    cancelamentoDiaria: false,
    historicoAgendamento: false,
    horaFixa: false,
    situacao: false,
    tipo: false,
  })

  const [loadAgend, setLoadAgend] = React.useState({
    page: true,
    list: false,
    diaria: true,
    pagina: false,
    horaFixa: true,
    avaliacao: false,
    cancelamento: false,
    cancelamentoDiaria: false,
  })

  function ReturnStatus() {
    switch (sttCtxAgend.typePed) {
      case 'Todos':
        return 'TODOS'
      case 'Solicitados':
        return 'SOLICITADO'
      case 'Agendados':
        return 'AGENDADO'
      case 'Realizados':
        return 'REALIZADO'
      case 'Cancelados':
        return 'CANCELADO'
      default:
        return 'TODOS'
    }
  }

  async function BuscarReagendamentosId(idpedido) {
    const req = await PedidoAPI.BuscarReagendamentoPorPedido(idpedido)
    if (req.error) {
      return
    }
    return req
  }

  const actionsAgend = {
    BuscarPedidoId: async idpedido => {
      setLoadAgend(loadAgend => ({ ...loadAgend, page: true }))
      const req = await PedidoAPI.BuscarPedidoId(idpedido)

      if (req.error) {
        return
      }
      if (req.mensalista_idmensalista !== null)
        req.valorAPagar = req.valorDesconto ? req.valorTotal - req.valorDesconto : req.valorTotal
      const reagendamentos = await BuscarReagendamentosId(idpedido)

      let objPedido = req
      if (reagendamentos.length > 0) {
        reagendamentos.sort((a, b) => a.idReagendamento - b.idReagendamento)
        objPedido = { ...req, reagendamentos: reagendamentos }
      } else {
        objPedido = { ...req, reagendamentos: [] }
      }
      setSttCtxAgend(sttCtxAgend => ({
        ...sttCtxAgend,
        pedido: objPedido,
        pedidoStt: {
          pedidoAprovado: req.dataAprovacao !== null,
          pedidoCriadoPorUser: req.marketplace,
          pedidoRealizado: req.status === 'REALIZADO',
          pedidoAvaliado: req.avaliacao_idavaliacao !== null,
          pedidoCancelado: req.status === 'CANCELADO',
        },
      }))
      setLoadAgend(loadAgend => ({ ...loadAgend, page: false }))
      return req
    },

    BuscarAgendamentosAvulsos: async countAll => {
      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: true }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: true }))
      const buffer = {
        idusuario: userUCtx.usuario.idusuario,

        status: ReturnStatus(),

        typePedido:
          sttCtxAgend.avulsoSel === 'Todos' ? 0 : sttCtxAgend.avulsoSel === 'Avulsos' ? 1 : 2,
        offset: countAll ? 0 : sttCtxAgend.offset,
        limit: 20,
        countAll,
      }
      const req = await UsuarioAPI.BuscarAgendamentosAvulsos(buffer)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema ao buscar os agendamentos. Por favor, verifique sua conexão com a internet e tente novamente.',
        )
      }

      if (req.retorno) {
        if (countAll) {
          setSttCtxAgend(prev => ({
            ...prev,
            avulsos: req.pedido.rows,
            maxScroll: req.pedido.count,
            offset: req.pedido.rows.length,
          }))
        } else {
          setSttCtxAgend(prev => ({
            ...prev,
            avulsos: [...prev.avulsos, ...req.pedido.rows],
            offset: prev.offset + req.pedido.rows.length,
          }))
        }
      }

      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: false }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: false }))
    },
    BuscarMensalistasUsuario: async countAll => {
      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: true }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: true }))

      const buffer = {
        idusuario: userUCtx.usuario.idusuario,
        offset: countAll ? 0 : sttCtxAgend.offset,
        limit: 20,
        countAll,
      }

      const req = await UsuarioAPI.BuscarMensalistasUsuario(buffer)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema ao buscar os contratos fixos. Por favor, verifique sua conexão com a internet e tente novamente.',
        )
      }
      if (req.retorno) {
        if (countAll) {
          setSttCtxAgend(prev => ({
            ...prev,
            fixos: req.mensalista.rows,
            maxScroll: req.mensalista.count,
            offset: req.mensalista.rows.length,
          }))
        } else {
          setSttCtxAgend(prev => ({
            ...prev,
            fixos: [...prev.fixos, ...req.mensalista.rows],
            offset: prev.offset + req.mensalista.rows.length,
          }))
        }
      }

      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: false }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: false }))
    },
    BuscarDiariasUsuario: async countAll => {
      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: true }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: true }))

      const buffer = {
        idusuario: userUCtx.usuario.idusuario,
        idempresa: null,
        data: null,
        limit: 20,
        offset: countAll ? 0 : sttCtxAgend.offset,
        countAll,
      }

      const req = await UsuarioAPI.BuscarDiariasUsuario(buffer)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema ao buscar as diárias. Por favor, verifique sua conexão com a internet e tente novamente.',
        )
      }

      if (req.retorno) {
        if (countAll) {
          setSttCtxAgend(prev => ({
            ...prev,
            diarias: req.dayUse.rows,
            maxScroll: req.dayUse.count,
            offset: req.dayUse.rows.length,
          }))
        } else {
          setSttCtxAgend(prev => ({
            ...prev,
            diarias: [...prev.diarias, ...req.dayUse.rows],
            offset: prev.offset + req.dayUse.rows.length,
          }))
        }
      }

      if (countAll) setLoadAgend(loadAgend => ({ ...loadAgend, list: false }))
      else setLoadAgend(loadAgend => ({ ...loadAgend, pagina: false }))
    },
    // BuscarRegraCancelamentoId: async () => {
    //   if (!loadAgend.cancelamento) setLoadAgend(loadAgend => ({ ...loadAgend, cancelamento: true }))

    //   const req = await PedidoAPI.BuscarRegraCancelamentoId(sttCtxAgend.pedido.idpedido)
    //   console.log('Regra cancelamento', req)
    //   if (req.error) {
    //     console.error('Erro ao buscar regra de cancelamento', req.error)
    //     return false
    //   }
    //   if (req.retorno) {
    //     setSttCtxAgend(prev => ({
    //       ...prev,
    //       pedido: { ...prev.pedido, regraCancelamento: req.regraCancelamento },
    //     }))
    //   }
    // },
    CancelarAgendamento: async motivo => {
      setLoadAgend(loadAgend => ({ ...loadAgend, cancelamento: true }))

      const data = {
        idpedido: sttCtxAgend.pedido.idpedido,
        motivoCancelamento: motivo,
      }

      const req = await PedidoAPI.CancelarAgendamento(data)

      if (req.error) {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que tivemos um problema ao cancelar o agendamento. Por favor, verifique sua conexão com a internet e tente novamente.',
        )
      }

      if (req.retorno) {
        Alerts.swal('success', 'Sucesso', 'Agendamento cancelado com sucesso!')
        setModaisAgend(modaisAgend => ({ ...modaisAgend, cancelamento: false }))
        await actionsAgend.BuscarPedidoId(sttCtxAgend.pedido.idpedido)
      }
      setLoadAgend(loadAgend => ({ ...loadAgend, cancelamento: false }))
    },
    ReagendarAgendamento: () => {
      setSttCtxAgend(sttCtxAgend => ({
        ...sttCtxAgend,
        reagendamento: {
          ...sttCtxAgend.pedido,
          valorRealizado:
            sttCtxAgend.pedido.valorRealizado === null ? 0 : sttCtxAgend.pedido.valorRealizado,
        },
      }))
    },
    ResetReagendamento: () => {
      setSttCtxAgend(sttCtxAgend => ({
        ...sttCtxAgend,
        reagendamento: {},
      }))
    },
    // CancelarDiaria: async motivo => {},
    handleSttCtxAgend: (key, value) =>
      setSttCtxAgend(sttCtxAgend => ({ ...sttCtxAgend, [key]: value })),
    handleModaisAgend: (key, value) =>
      setModaisAgend(modaisAgend => ({ ...modaisAgend, [key]: value })),
    handleLoadAgend: (key, value) => setLoadAgend(loadAgend => ({ ...loadAgend, [key]: value })),
  }

  const actionsHoraFixa = {
    BuscarHoraFixaId: async idmensalista => {
      setLoadAgend(prev => ({ ...prev, horaFixa: true }))
      const req = await PedidoAPI.BuscarMensalistaId(idmensalista)

      if (req.error) {
        return false
      }

      setSttCtxAgend(sttCtxAgend => ({ ...sttCtxAgend, horaFixaSelected: req }))
      setLoadAgend(prev => ({ ...prev, horaFixa: false }))
      return req
    },
  }

  const actionsDiaria = {
    BuscaDiariaId: async idcompraDayuse => {
      setLoadAgend(prev => ({ ...prev, diaria: true }))
      const req = await PedidoAPI.BuscarDiariaId(idcompraDayuse)

      if (req.error) {
        setSttCtxAgend(sttCtxAgend => ({ ...sttCtxAgend, erroComunic: true }))
        setLoadAgend(prev => ({ ...prev, diaria: false }))
        return req
      } else {
        setSttCtxAgend(sttCtxAgend => ({ ...sttCtxAgend, diariaSel: req }))
      }
      setLoadAgend(prev => ({ ...prev, diaria: false }))
      return req
    },
    CancelarDiaria: async motivo => {
      const RunScript = async () => {
        const data = {
          motivoCancelamento: motivo,
          idcompraDayuse: sttCtxAgend.diariaSel.idcompraDayuse,
          canceladoPor: userUCtx.usuario.nome,
        }

        const req = await UsuarioAPI.CancelarDiaria(data)

        if (req.error) {
          Alerts.swal(
            'warning',
            'Aviso',
            'Parece que tivemos um problema ao cancelar a diária. Por favor, verifique sua conexão com a internet e tente novamente.',
          )
        }

        if (req.retorno) {
          Alerts.swal('success', 'Sucesso', 'Diária cancelada com sucesso!')
          setModaisAgend(modaisAgend => ({ ...modaisAgend, cancelamentoDiaria: false }))
          await actionsDiaria.BuscaDiariaId(sttCtxAgend.diariaSel.idcompraDayuse)
        }
        setLoadAgend(prev => ({ ...prev, cancelamentoDiaria: false }))
      }

      setLoadAgend(prev => ({ ...prev, cancelamentoDiaria: true }))

      const valid = await AuthAPI.getDateTimer()

      if (!valid?.time) {
        // Se não conseguir validar a hora, faz o cancelamento normalmente
        return await RunScript()
      }

      const serverMoment = moment.parseZone(valid.time).local()
      const nowLocal = moment()
      const diffMin = Math.abs(serverMoment.diff(nowLocal, 'minutes'))

      if (diffMin > 15) {
        if (serverMoment.isBefore(nowLocal)) {
          Alerts.swal(
            'warning',
            'Aviso',
            'A data e hora do seu dispositivo estão incorretas e impossibilitam o cancelamento. Ajuste-as configurações automáticas para prosseguir.',
          )
          setLoadAgend(prev => ({ ...prev, cancelamentoDiaria: false }))
          return
        }
        // Caso esteja fora da tolerância, mas a data do servidor ainda esteja válida (não no passado)
        // podemos permitir o cancelamento continuar normalmente
      }

      return await RunScript()
    },

    handleModaisAgend: (key, value) =>
      setModaisAgend(modaisAgend => ({ ...modaisAgend, [key]: value })),
  }

  return (
    <AgendamentoContext.Provider
      value={{ sttCtxAgend, modaisAgend, loadAgend, actionsAgend, actionsHoraFixa, actionsDiaria }}
    >
      {children}
    </AgendamentoContext.Provider>
  )
}
